import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "disabled", "falseValue", "children", "value", "trueValue", "style", "indeterminate", "title"];
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc, createElementVNode as _$ce } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Wave } from '../wave';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    disabled = _this$get.disabled,
    falseValue = _this$get.falseValue,
    children = _this$get.children,
    value = _this$get.value,
    trueValue = _this$get.trueValue,
    style = _this$get.style,
    indeterminate = _this$get.indeterminate,
    title = _this$get.title,
    rest = _objectWithoutPropertiesLoose(_this$get, _excluded);
  var isChecked = this.isChecked();
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-checkbox"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-checked"] = isChecked, _classNameObj[k + "-indeterminate"] = indeterminate, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var events = ['ev-click', 'ev-change', 'ev-mouseenter', 'ev-mouseleave'].reduce(function (memo, name) {
    if (rest[name]) {
      if (name === 'ev-click' || name === 'ev-change') {
        // do not bind click to label, otherwise it will trigger click event twice
        // don't bind change to input, use click instead of, #448
        // evClick = rest[name];
      } else {
        memo[name] = rest[name];
      }
      delete rest[name];
    }
    return memo;
  }, {});
  return _$cv('label', _extends({
    'className': _$cn(classNameObj),
    'style': style,
    'tabindex': disabled ? null : "0",
    'title': title,
    'ev-click': this.onClick,
    'ev-keypress': this.onKeypress
  }, events), [_$cc(Wave, {
    'disabled': disabled,
    'inset': '-2px',
    'children': _$ce(2, 'span', _$cv('input', _extends({
      'type': 'checkbox',
      'checked': isChecked,
      'value': trueValue,
      'trueValue': trueValue,
      'falseValue': falseValue,
      'disabled': disabled,
      'tabindex': '-1',
      'ref': this.inputRef
    }, getRestProps(this, rest))), 2, _$cn(k + "-checkbox-wrapper"))
  }), children ? _$ce(2, 'span', children, 0, _$cn(k + "-checkbox-text")) : undefined]);
}
;